module.exports = __webpack_public_path__ + "static/media/03. Devanna Kamath With Puppet Team.0bfcbef5.jpg";